import { useBoundDeep } from "@repo/shared/common";
import { BoundAsyncSelect, useAsyncSelectStaticListHook } from "@repo/shared/components";
import { useTranslation } from "next-i18next";
import React from "react";

import type { Account, DiscountProfileEntry, TermsOfPayment } from "../types/ContactTypes";
import type { ErrorMap } from "@repo/shared/common";
import type { SetStateAction } from "react";

type TermOfPaymentItemProps = {
	term: TermsOfPayment;
	index: number;
	contact: Account;
	setContact: (value: SetStateAction<Account>) => void;
	errors?: ErrorMap;
	setErrors?: (value: SetStateAction<ErrorMap>) => void;
};

export const TermOfPaymentItem = (props: TermOfPaymentItemProps) => {
	const { t } = useTranslation();
	const { term, index, contact, setContact, errors = {}, setErrors = () => {} } = props;

	const useBinding = <TValue,>(selector: (m: Account) => TValue) => {
		return useBoundDeep<Account, TValue>(contact, setContact, selector, errors, setErrors);
	};

	const selectedEntry = useBinding((p) => p.termsOfPaymentEntries[index].selectedEntry);
	const discountProfiles = useAsyncSelectStaticListHook<DiscountProfileEntry>(term.entries || []);

	return (
		<div key={term.id} className="w-100">
			<div className="left w-20 textCenter padding11">{term.company.name.toLocaleUpperCase()}</div>
			<div className="left w-40">
				<BoundAsyncSelect
					label={t("discount")}
					boundedValue={selectedEntry}
					searchHook={discountProfiles}
					additionalProps={{ className: "w-100 left" }}
				/>
			</div>
			<div className="clear" />
		</div>
	);
};
